export default function (cguLink, $el) {
	const _self = this,
		_$el = $el,
		_components = {
			$consentDiv: null,
			$consentOverlay: null,
		},
		test = false,
		date = getLegalExpirationDate();

	/**
	 * init function
	 *
	 * @private
	 */
	function _init() {
		_createConsentDiv();
		_displayConsentDiv();

		_onAccept();
		_onRefuse();
	}

	/**
	 * Créer la div de consentement
	 *
	 * @private
	 */
	function _createConsentDiv() {
		let modal = _generateCookieSeetingsModal(),

		html = 	'<div id="privacy-consent" style="display: none;" >';
		// html += 	modal;
		html +=
			'<div class="privacy-consent-container">' +
			'<div class="consent">' +
			'<h2 class="consent-title">' +
			'Votre vie privée est notre priorité <i class="fa-duotone fa-lock"></i>' +
			'</h2>' +
			'<p class="consent-text">' +
			'En continuant votre navigation vous nous autorisez à utiliser des cookies pour vous offrir la meilleure expérience possible.' +
			'</p>' +
			'<p class="consent-text">' +
			'Pour plus d\'information, rendez-vous sur notre page de <a href="' + cguLink + '"> Condition generales d\'utilisation </a> ' +
			'</p>' +
			'</div>' +
			'<div class="consent-buttons">' +

			// '<button class="btn customise-cookies-btn btn-padded" data-toggle="modal" data-target="#customise-cookies-modal"><i class="fa-duotone fa-wrench"></i></i>Personaliser mes cookies</button>' +
			'<button class="btn accept-consent-btn btn-padded"><i class="fa-solid fa-check"></i>C\'est bon pour moi</button>' +
			'<div class="refuse-consent-btn">Continuer sans accepter</div >' +
			'</div>' +
			'</div>' +
			'</div>' +
			'  </div>';
		_components.$consentDiv = $(html);
		_components.$consentOverlay = $('' +
			'<div id="privacy-consent-overlay" style="display: none;" ></div>')
	}

	 function _generateCookieSeetingsModal(){
		let modal =		'  <div class="modal fade" id="customise-cookies-modal" role="dialog">' +
		'    <div class="modal-dialog">' +
		'      <!-- Modal content-->' +
		'      <div class="modal-content">' +
		'        <div class="modal-header">' +
		'          <button type="button" class="close" data-dismiss="modal">&times;</button>' +
		'          <h4 class="modal-title">Personnaliser vos préference :</h4>' +
		'        </div>' +
		'        <div class="modal-body">' +
		'          <p>Lorsque vous consultez un site web, certaines informations peuvent être stockées ou récupérées, principalement sous la forme de cookies. Ces informations peuvent être relatives à vos préférences, à l\'appareil que vous utilisez ou vous concerner personnellement. Elles sont principalement utilisées pour faire en sorte que le site fonctionne conformément à vos attentes. Elles ne permettent généralement pas de vous identifier directement, mais elles peuvent vous offrir une expérience de navigation plus personnalisée sur le site. Comme nous respectons votre droit à la vie privée, vous pouvez choisir de ne pas autoriser certains types de cookies. Cliquez sur les différents en-têtes de catégorie pour en savoir plus et modifier nos paramètres par défaut. Sachez toutefois que le blocage de certains types de cookies peut avoir un impact sur votre utilisation du site et sur les services que nous pouvons offrir.</p>' +
		'    <div class="row">' +
			'<div class="col-10">' +
			'<p>Essentiels</p>' +
			'</div>' +
			'<div class="col-2">' +
			'<button type="button" class="btn btn-primary" data-toggle="button" aria-pressed="false">\n' +
			'  Single toggle\n' +
			'</button>' +
			'</div>' +
			'</div>    ' +
			'</div>' +
		'        <div class="modal-footer">' +
		'          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>' +
		'        </div>' +
		'      </div>' +
		'   </div>   ' +
		'</div>' ;

		return modal;
	}

	/**
	 * Si pas encore accepté ou refusé, afficher la popup de consentement
	 *
	 * @private
	 */
	function _displayConsentDiv() {
		let timeToWhait = 60000,
			timeToWhaitAfterUserAction = 3000,
			executed = false;

		if (test) {
			timeToWhait = 0;
		}


		if (test || document.cookie.split(';').filter(function (item) {
			return item.indexOf('privacy_consent=false') >= 0 || item.indexOf('privacy_consent=true') >= 0;
		}).length === 0) {
			$(window).on('click scroll', function () {
				setTimeout(function () {
					if (!executed) {
						_appendConsentDiv();
						executed = true;
					}
					;

				}, timeToWhaitAfterUserAction)
			});
			setTimeout(function () {
				if (!executed) {
					_appendConsentDiv();
					executed = true;
				}
				;
			}, timeToWhait)

		}


	}

	/**
	 * Si pas encore accepté ou refusé, afficher la popup de consentement
	 *
	 * @private
	 */
	function _appendConsentDiv() {
		const delay = 500;
		_components.$consentOverlay.appendTo($('body')).fadeIn(delay);
		setTimeout(function () {
			_components.$consentDiv.appendTo($('body')).slideDown(delay);
		}, delay / 2)
	}

	/**
	 * Accepte les cookies et trackers
	 *
	 * @private
	 */
	function _onAccept() {
		_components.$consentDiv.find('.accept-consent-btn').on('click', function () {
			document.cookie = "privacy_consent=true;path=/; " + date.toUTCString();
			_components.$consentDiv.fadeOut('normal', function () {
				$(this).remove();
			})
			_components.$consentOverlay.fadeOut('normal', function () {
				$(this).remove();
			})
		});

	}

	/**
	 * Refuse les cookies et trackers
	 *
	 * @private
	 */
	function _onRefuse() {
		_components.$consentDiv.find('.refuse-consent-btn').on('click', function () {
			document.cookie = "privacy_consent=false;path=/; " + date.toUTCString();
			document.location.reload();
		})
	}

	/**
	 * Date d'expiration légale du cookie = 12 mois
	 *
	 * @returns {Date}
	 */
	function getLegalExpirationDate() {
		const date = new Date();
		date.setFullYear(date.getFullYear() + 1);
		return date;
	}

	$(document).ready(function () {
		_init();
	});
}
